module.exports = __webpack_public_path__ + "img/receipt_preview.4a2ce2b1.png";